export const FRONTEND_DIAGNOSTIC_EVENT = 'frontend-diagnostic';

export type IntegrationCatalogComingSoonDetail = {
  type: 'integration_catalog_coming_soon';
  integration_id: string;
  integration_name: string;
  href?: string;
  timestamp: string;
  context?: Record<string, unknown>;
};

/** Log a coming-soon integration request via custom event + console. */
export function reportIntegrationCatalogComingSoon(
  integrationId: string,
  integrationName: string,
  context?: Record<string, unknown>
): void {
  const detail: IntegrationCatalogComingSoonDetail = {
    type: 'integration_catalog_coming_soon',
    integration_id: integrationId,
    integration_name: integrationName,
    href: typeof window !== 'undefined' ? window.location.href : undefined,
    timestamp: new Date().toISOString(),
    context,
  };

  console.warn('[integration-catalog] coming soon requested', detail);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(FRONTEND_DIAGNOSTIC_EVENT, { detail }));
  }
}
